import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useStore } from "@/store";
import { computed, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Clients',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Klienci"))
}
}

})